 ( function ($) {
	var $searchInput, $searchMod,
		BODY_OPEN_CLASS = 'modal-open',
		MODAL_OPEN_CLASS = 'isOpen';

	$(document).ready( function() {
		$searchInput = $( '#header-search' );
		$searchMod = $searchInput.closest( '.modal' );

		$( '.open-modal-search' ).on( 'click', function() {
			onClickSearchBtn();
			
			setTimeout( function() {
				$searchInput.select();
			}, 500 );
		} );

		$searchMod.find( '.closebutton' ).on( 'click', closeSearchModal );

		function onClickSearchBtn() {
			$( 'body' ).addClass( BODY_OPEN_CLASS );
			$searchMod.addClass( MODAL_OPEN_CLASS );
			$searchMod.find( '[type="submit"]' ).prop( 'disabled', false ); // Search button are now enabled.}
		}

		function closeSearchModal(){
			if ( $searchMod.length ) {
				$searchMod.removeClass( MODAL_OPEN_CLASS );
				$searchInput.val( '' );
				setTimeout( function() {
					$( 'body' ).removeClass( BODY_OPEN_CLASS );
				}, 10 );
			}
		}
	} );
} )( jQuery );